import {IMaskDirective} from 'vue-imask';

export const Input = {
    name: 'Input',
    inheritAttrs: false,
    props: {
        isInvalid: Boolean,
        type: String,
        inputClasses: String,
        value: [String, Number],
        disabled: Boolean,
        mask: [String, RegExp, Function],
        maskOptions: Object,
        isHighlighted: Boolean
    },
    directives: {
        imask: IMaskDirective
    },
    watch: {
        value(newValue) {
            if (this.mask && this.$el.maskRef) {
                this.$el.maskRef.value = newValue;
            }
        }
    },
    computed: {
        classes() {
            return [
                'input',
                this.isHighlighted && 'input--highlighted',
                this.isInvalid && 'input--invalid',
                this.inputClasses
            ];
        },
        imask() {
            if (!this.mask) {
                return;
            }

            return {
                mask: this.mask,
                ...(this.maskOptions || {})
            }
        },
        listeners() {
            const {input, ...listeners} = this.$listeners;
            if (this.mask) {
                return {
                    ...listeners,
                    accept: e => {
                        this.$emit('input', e.detail.value)
                    }
                }
            } else {
                return {
                    ...listeners,
                    input: (e) => {
                        input && input(e.target.value);
                    }
                };
            }
        },
    },
    template: `
        <input :type="type" 
                :class="classes"
                :value="value"
                v-imask="imask"
                v-on="listeners"
                :disabled="disabled"
                v-bind="$attrs"/>
    `
};
